export * from './felder-sorter.component';
export * from './felder-sorter.component.module';